import { StockStatus } from '@/types/entity/product';

// EWM-545 — a product with no stock shows "Stock due soon" instead of
// "Out of stock" when it's a new/pending arrival (productLifeCycle N or P).
// The no-stock signal is unchanged (`!inStock || stockUnavailable`); this
// only re-labels the no-stock case. It does NOT affect Add-to-Cart gating —
// a due-soon product is still out of stock for purchase.
export const resolveStockStatus = ({
  inStock,
  stockUnavailable,
  isStockDueSoonEligible,
}: {
  inStock?: boolean;
  stockUnavailable?: boolean;
  isStockDueSoonEligible?: boolean;
}): StockStatus => {
  const noStock = !inStock || !!stockUnavailable;
  if (!noStock) return 'in-stock';
  return isStockDueSoonEligible ? 'due-soon' : 'out-of-stock';
};
